import {
  IP_MARKETPLACE_LIST_ERROR,
  IP_MARKETPLACE_LIST_SUCCESS,
  IP_MARKETPLACE_LIST_REQUEST,
} from "./constants";

const initialState = {
  loading: false,
  data: [],
};

export default function IPMarketplaceListReducer(state = initialState, action) {
  switch (action.type) {
    case IP_MARKETPLACE_LIST_REQUEST:
      return { ...state, loading: true };
    case IP_MARKETPLACE_LIST_SUCCESS:
      return {
        ...state,
        data: action.data,
        loading: false,
      };
    case IP_MARKETPLACE_LIST_ERROR:
      return { ...state, loading: false };

    default:
      return state;
  }
}
